export default "__VITE_ASSET__DbpWOg0j__"